import { render, staticRenderFns } from "./complexItemsList.vue?vue&type=template&id=70d6ff3e&"
import script from "./complexItemsList.vue?vue&type=script&lang=js&"
export * from "./complexItemsList.vue?vue&type=script&lang=js&"
import style0 from "./complexItemsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports